module.exports = __webpack_public_path__ + "img/au.7c225c04.svg";